/* eslint-disable */
export default {
  DirectNumber: 'Suora',
  MainCompanyNumber: 'Päänumero',
  CompanyNumber: 'Yritys',
  CompanyFaxNumber: 'Faksi',
  Blocked: 'Estetty',
  AdditionalCompanyNumber: 'Yritys',
  ForwardedCompanyNumber: 'Siirretty',
  from: 'Läh.',
} as const;

// @key: @#@"DirectNumber"@#@ @source: @#@"Direct"@#@
// @key: @#@"MainCompanyNumber"@#@ @source: @#@"Main"@#@
// @key: @#@"CompanyNumber"@#@ @source: @#@"Company"@#@
// @key: @#@"CompanyFaxNumber"@#@ @source: @#@"Fax"@#@
// @key: @#@"Blocked"@#@ @source: @#@"Blocked"@#@
// @key: @#@"AdditionalCompanyNumber"@#@ @source: @#@"Company"@#@
// @key: @#@"ForwardedCompanyNumber"@#@ @source: @#@"Forwarded"@#@
// @key: @#@"from"@#@ @source: @#@"From"@#@
